import { Col, Container, Row } from "reactstrap";

const Benefit = () => {

  const listBenefits = [
    { title:"Skill Demand untuk Kerja Nyata", body:"Kuliah yang langsung nyambung ke skill profesional penting di industri Kanada maupun global." },
    { title:"Peluang Karier di Kanada", body:"Banyak program yang eligible buat Post-Graduation Work Permit (PGWP) — kerja setelah lulus jadi lebih nyata!." },
    { title:"Dukungan untuk Internasional", body:"Ada layanan support dari awal sampai proses adaptasi hidup di Kanada — termasuk info housing, visa, dan lainnya." },
    { title:"Biaya Hidup Lebih Chill", body:"Kota-kota kampus NLC di British Columbia punya biaya hidup yang lebih nyaman dibanding big cities seperti Vancouver atau Toronto." },
  ]

  return (
    <section className="section benefit-wrapper" id="benefit">
      <Container>
        <Row>
          <Col xs='12' md='7' className="benefit-items">
            <h1><b>Benefit Kuliah di Northern Lights College</b></h1>
              <ol>
                {listBenefits.map((item, id) => (
                  <li key={id}>
                    {item.title}
                    <p className="fw-normal">{item.body}</p>
                  </li>
                ))}
              </ol>
          </Col>    
          <Col xs='12' md='5' className='benefit-bg'>
            <img 
              src="assets/images/benefit-bg.webp" 
              alt="student-searching-benefits-study-at-melbourne-poly" 
              className="img-fluid"
            />
          </Col>        
        </Row>
      </Container>
    </section>
  );
};

export default Benefit;